import { render } from "./collection-highlilghted-products.vue?vue&type=template&id=7f4e8dbf"
import script from "./collection-highlilghted-products.vue?vue&type=script&lang=js"
export * from "./collection-highlilghted-products.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__